import { render, staticRenderFns } from "./registeredCustomers.vue?vue&type=template&id=05d91308"
import script from "./registeredCustomers.vue?vue&type=script&lang=js"
export * from "./registeredCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports